
import { listFiles } from 'Api/file';
import { useQuery } from 'react-query';

export const useGetListFiles = (
  currentPage,
  searchQuery,
  documentType,
  filters,
  userToken,
  enableFetching,
) => {
  const { isLoading, isFetching, data, isError } = useQuery(
    ['ListFiles', currentPage, searchQuery, documentType, filters, userToken],
    listFiles,
    {
      staleTime: Infinity,
      keepPreviousData: true,
      enabled: enableFetching,
    },
  );
  return { isLoading, isFetching, data, isError };
};
